<template>
    <img
        v-if="lazyLoad && image.src"
        :data-src="image.src"
        :data-srcset="image.srcSet"
        :sizes="sizes"
        :width="image.width"
        :height="image.height"
        class="lazyload"
    />
    <v-img
        v-else-if="image.src"
        :src="image.src"
        :srcset="image.srcSet"
        :sizes="sizes"
        :width="image.width"
        :height="image.height"
        :aspect-ratio="aspectRatio"
    />
</template>

<script>
export default {
    name: 'ResponsiveImage',

    props: {
        imageName: {
            type: String,
            required: true,
        },
        sizes: {
            type: String,
            default: '(max-width: 600px) 600px, (max-width: 960px) 960px, 90vw',
        },
        fullWidth: {
            type: Boolean,
            default: false,
        },
        smallWidth: {
            type: Boolean,
            default: false,
        },
        withDimensions: {
            type: Boolean,
            default: false,
        },
        lazyLoad: {
            type: Boolean,
            default: true,
        },
        aspectRatio: {
            type: String,
        },
    },

    data: () => ({
        image: {
            src: null,
            srcSet: null,
        },
    }),
    created() {
        ;(async () => {
            const { width, height, ...image } = await this.importImage(
                this.imageName,
                this.fullWidth,
                this.smallWidth,
            )

            this.image = {
                ...image,
                ...(this.withDimensions ? { width, height } : {}),
            }
        })()
    },

    methods: {
        importImage: async (imageName, fullWidth, smallWidth) => {
            let img
            const imageWithExtension = imageName.match(
                /\.(jpe?g|png|gif|webp)$/,
            )
                ? imageName
                : `${imageName}.jpg`

            if (fullWidth) {
                img = await import(
                    /* webpackMode: 'eager' */ `~/assets/images/${imageWithExtension}?resize&sizes[]=600&sizes[]=960&sizes[]=1264&sizes[]=1900`
                )
            } else if (smallWidth) {
                img = await import(
                    /* webpackMode: 'eager' */ `~/assets/images/${imageWithExtension}?resize&sizes[]=600&sizes[]=900`
                )
            } else {
                img = await import(
                    /* webpackMode: 'eager' */ `~/assets/images/${imageWithExtension}?resize&sizes[]=600&sizes[]=960&sizes[]=1264`
                )
            }

            return img
        },
    },
}
</script>
